import { render, staticRenderFns } from "./block0.vue?vue&type=template&id=46b36379&scoped=true&"
import script from "./block0.vue?vue&type=script&lang=js&"
export * from "./block0.vue?vue&type=script&lang=js&"
import style0 from "./block0.vue?vue&type=style&index=0&id=46b36379&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b36379",
  null
  
)

export default component.exports